import IconText from '../../components/iconText/IconText'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { useAppSelector } from '../../redux/hooks'
import { InstructorProfileData } from '../../server/types'
import { getLanguageString, getTerrainString } from '../../utils/RetrieveStrings'
import './style.scss'

interface InstructorProfileHighlightCardProps {
	profileData: InstructorProfileData
}

function InstructorProfileHighlightCard({profileData}: InstructorProfileHighlightCardProps) {
	const reviewsCount: number = useAppSelector((state) => state.instructor.reviewCount)
	
	return (
		<div className='section-content'>
			<div className='instructor-profile-highlight-section'>
				<div className='instructor-profile-highlight-card-wrap'>
					<div className='instructor-profile-highlight-card'>
						<div className='instructor-profile-highlight-card-personal-wrap'>
							<img
								className='instructor-profile-highlight-card-personal-img'
								alt='User'
								// src='/imgs/temp/profile_thumbnails/profile-00000.png'
								src={getProfilePicPath(profileData.profile_pics, 0)}
							/>
							<div className='instructor-profile-highlight-card-personal-name'>{profileData.name}</div>
							<div className='instructor-profile-highlight-card-personal-type'>Instructor</div>
							<div className={`instructor-profile-highlight-card-personal-level instructor-profile-highlight-card-personal-level-${profileData.level}`}>{`Level ${profileData.level}`}</div>
						</div>
						<div className='instructor-profile-highlight-card-details-wrap'>
							<div className='instructor-profile-highlight-card-details-item'>
								<div className='instructor-profile-highlight-card-details-value'>{reviewsCount}</div>
								<div className='instructor-profile-highlight-card-details-label'>Reviews</div>
							</div>
							<div className='instructor-profile-highlight-card-details-item'>
								<div className='instructor-profile-highlight-card-details-value'><IconText text={`${profileData.rating_overall ? profileData.rating_overall : 0} [[icon-star]]`} /></div>
								<div className='instructor-profile-highlight-card-details-label'>Rating</div>
							</div>
							<div className='instructor-profile-highlight-card-details-item'>
								<div className='instructor-profile-highlight-card-details-value'>{profileData.years_of_experience}</div>
								<div className='instructor-profile-highlight-card-details-label'>Year Experience</div>
							</div>
						</div>
					</div>
					{/* <div className='instructor-profile-highlight-school-wrap'>
						<div className='instructor-profile-highlight-school-name'>{getSchoolString(profileData.school)}</div>
						<div className='instructor-profile-highlight-school-catch-line'>This Ski School offers private in person lessons. Starting from $115 per hour.</div>
						<CtaButton
							label='Book Lesson'
							onClick={() => console.log('[InstructorProfileHighlightCard] - Book Lesson Click')}
							size='large'
						/>
					</div> */}
				</div>
				<div className='instructor-profile-highlight-filters-wrap'>
					{
						profileData.terrains && profileData.terrains.length > 0 && (
							<div className='instructor-profile-highlight-filter'>
								<div className='instructor-profile-highlight-filter-icon-wrap'>
									<img
										className='instructor-profile-highlight-filter-icon'
										alt='Terrain'
										src='/imgs/icons/icon-terrain-alt.svg'
									/>
								</div>
								<div className='instructor-profile-highlight-filter-text'>
									Terrain - {profileData.terrains.split(',').map((terrainIndex: string) => getTerrainString(terrainIndex)).join(', ')}
								</div>
							</div>
						)
					}
					{
						profileData.languages && profileData.languages.length > 0 && (
							<div className='instructor-profile-highlight-filter'>
								<div className='instructor-profile-highlight-filter-icon-wrap'>
									<img
										className='instructor-profile-highlight-filter-icon'
										alt='Languages'
										src='/imgs/icons/icon-language-alt.svg'
									/>
								</div>
								<div className='instructor-profile-highlight-filter-text'>
									Fluent in {profileData.languages.split(',').map((terrainIndex: string) => getLanguageString(terrainIndex)).join(', ')}
								</div>
							</div>
						)
					}
				</div>
			</div>
		</div>
	)
}

export default InstructorProfileHighlightCard